export default __webpack_public_path__ + "static/media/ROM.59ca825a.pdf";